<script>
    import Main from '@/mixins/main';
    import Size from '@/mixins/size';
    import {Field, Button} from 'vant';
    import CarNumberKeyboard from '@/components/CarNumberKeyboard';
    import {getCarNumberAndOrderSn, getParkFee, payParkFee} from '@/api';

    export default {
        mixins: [
            Main,
            Size
        ],
        components: {
            CarNumberKeyboard,
            [Field.name]: Field,
            [Button.name]: Button
        },
        props: {
            q: {
                type: String
            },
            scene: {
                type: String
            },
            orderSn: {
                type: String
            }
        },
        data() {
            return {
                tab: 0,
                orderSns: [],
                stationCode: '',
                carNumber: '',
                // 是否传入订单号
                hasPassOrderSn: false,

                queryDisabled: true,
                queryLoading: false,
                useBalance: false,
                payDisabled: false,
                payLoading: false,
                parkFee: null,
                payFeeButtonText: '立即付款'
            };
        },
        mounted() {
            window.document.title = '速电通-停车缴费';

            if (!this.isLogin()) {
                this.$router.push({name: 'login'});
                return;
            }

            this.tab = 0;

            this.stationCode = this.scene;

            if (this.q) {
                let pos = this.q.indexOf('stationCode%3D');
                if (pos > 0) {
                    this.stationCode = this.q.substr(pos + 14);
                }
            }

            if (!this.orderSn) {
                this.orderSns = [{index: 0, sn: ''}];
            } else {
                this.hasPassOrderSn = true;
                this.orderSns = [{index: 0, sn: this.orderSn}];
            }

            this.fillCarNumberOrderSns();
        },
        computed: {
            orderSnsArr() {
                return this.orderSns.map(item => item.sn);
            },
            payable() {
                return this.parkFee ? (this.parkFee.payable / 100).toFixed(2) : 0.00;
            }
        },
        methods: {
            carNumberValid(carNumber) {
                this.carNumber = carNumber;
                this.queryDisabled = false;
                this.fillCarNumberOrderSns();
            },
            // 添加订单输入框
            addOrder() {
                this.orderSns.push({index: this.orderSns.length, sn: ''});
            },
            orderSnChange(e) {
                let index = e.mp.currentTarget.dataset.index;
                for (let i = 0, len = this.orderSns.length; i < len; i++) {
                    if (this.orderSns[i].index === index) {
                        this.orderSns[i].sn = e.mp.detail;
                        break;
                    }
                }
            },
            fillCarNumberOrderSns() {
                getCarNumberAndOrderSn(this.stationCode, this.carNumber).then(response => {
                    if (response.data.code === '000000') {
                        if (!this.carNumber && response.data.body.carNumber) {
                            this.queryDisabled = false;
                            this.carNumber = response.data.body.carNumber;
                        }

                        if (!this.hasPassOrderSn && response.data.body.orderSns.length > 0) {
                            this.orderSns = response.data.body.orderSns.map((sn, index) => {
                                return {index: index, sn: sn};
                            });
                        }
                    }
                });
            },
            // 查询费用
            queryFee() {
                this.queryLoading = true;
                getParkFee(this.stationCode, this.carNumber, this.orderSnsArr).then(response => {
                    if (response.data.code === '000000') {
                        this.tab = 1;
                        this.payDisabled = false;
                        this.payFeeButtonText = '立即付款';
                        this.parkFee = response.data.body;
                    }
                }).finally(() => {
                    this.queryLoading = false;
                });
            },
            payFee() {
                this.payLoading = true;
                payParkFee(this.stationCode, this.carNumber, this.parkFee.orderNo, this.parkFee.freeTime, this.useBalance, this.orderSnsArr).then(response => {
                    if (response.data.code === '000000') {
                        if (response.data.body) {
                            WXP.requestPayment({
                                timeStamp: response.data.body.timeStamp,
                                nonceStr: response.data.body.nonceStr,
                                package: response.data.body.package,
                                signType: response.data.body.signType,
                                paySign: response.data.body.sign
                            }).then(res => {
                                this.payDisabled = true;
                                this.payFeeButtonText = '已付款';
                                WXP.showToast({title: '支付成功', icon: 'success', duration: 3000});
                            }).catch(error => {
                                WXP.showToast({title: '支付失败', icon: 'none', duration: 3000});
                            });
                        } else {
                            this.payDisabled = true;
                            this.payFeeButtonText = '已付款';
                            WXP.showToast({title: '支付成功', icon: 'success', duration: 3000});
                        }
                    } else if (response.data.code === '100091') {
                        this.payDisabled = true;
                        this.payFeeButtonText = '已付款';
                    }
                }).finally(() => {
                    this.payLoading = false;
                });
            }
        }
    }
</script>

<template>
    <car-number-keyboard v-if="tab === 0" :car-no="carNumber" @car-number-valid="carNumberValid">
        <div :style="{height: (height - 317) + 'px'}">
            <div class="order-sn">
                <div class="tip">
                    <div class="sdt-info1"></div>
                    输入充电订单号可减免停车时长
                </div>
                <van-field v-for="(item, index) in orderSns" :key="index" :data-index="item.index" clearable :value="item.sn" @change="orderSnChange" placeholder="请至少输入第三方充电订单号后六位">
                    <div slot="button" class="add-order" @click="addOrder">+</div>
                </van-field>
            </div>
            <div class="submit-button">
                <van-button block color="#009251" custom-style="box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);" loading-text="查询中..." :disabled="queryDisabled" :loading="queryLoading" @click="queryFee">查询停车费</van-button>
            </div>
        </div>
    </car-number-keyboard>
    <div v-else id="showParkFee">
        <div class="park-name center">{{parkFee.parkName}}</div>
        <div class="car-number center">{{parkFee.carNumber}}</div>
        <div class="detail">
            <div class="v-split-line"></div>
            <div class="item">
                <div class="label">入场时间</div>
                <div class="value">{{parkFee.entryTimeShow}}</div>
            </div>
            <div class="item">
                <div class="label">停车时长</div>
                <div class="value">{{parkFee.elapsedTimeShow}}</div>
            </div>
            <div class="item">
                <div class="label">减免时长</div>
                <div class="value">{{parkFee.freeTimeShow}}</div>
            </div>
        </div>
        <div class="submit-button">
            <div class="label">应付停车费</div>
            <div class="pay-money">
                <div class="left">
                    <div class="money">{{parkFee.payableShow}}元</div>
                    <div v-if="parkFee.balance" class="balance">/账户余额￥{{parkFee.balance}}元</div>
                </div>
                <div v-if="parkFee.balance" class="use-balance" @click="useBalance = !useBalance">
                    <div :class="{'sdt-check-off': !useBalance, 'sdt-check-on': useBalance}"/>
                    <div class="text">使用余额</div>
                </div>
            </div>
            <div class="tip">
                <div class="sdt-info"></div>
                请于付款后{{parkFee.delayTime}}分钟内离场，超时将加收停车费
            </div>
            <van-button block color="#009251" custom-style="box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);" loading-text="处理中..." :disabled="payDisabled" :loading="payLoading" @click="payFee">{{payFeeButtonText}}</van-button>
        </div>
        <div class="car-entry-img">
            <van-image width="240" height="180" radius="4" lazy-load :src="parkFee.imgName"/>
        </div>
    </div>
</template>

<style scoped>
    #carNumberKeyboard {
        display: flex;
        flex-direction: column;
    }

    #carNumberKeyboard .order-sn {
        padding: 24px 0 16px 0;
    }

    #carNumberKeyboard .order-sn .tip {
        display: flex;
        align-items: center;
        color: #666666;
        font-size: 14px;
        padding: 0 16px;
    }

    #carNumberKeyboard .order-sn .tip .sdt-info1 {
        display: flex;
        margin-right: 2px;
        align-items: center;
    }

    #carNumberKeyboard .order-sn .add-order {
        display: flex;
        font-size: 22px;
        padding-left: 8px;
        font-weight: bold;
        align-items: center;
        justify-content: center;
    }

    #carNumberKeyboard .submit-button {
        padding: 6px 24px 0 24px;
    }

    #showParkFee {
        height: 100%;
        background-color: #F6F9F8;
    }

    #showParkFee .center {
        text-align: center;
        background-color: white;
    }

    #showParkFee .park-name {
        color: #666666;
        font-size: 14px;
        font-weight: 400;
        padding-top: 16px;
    }

    #showParkFee .car-number {
        color: #666666;
        font-size: 18px;
        font-weight: 400;
        padding-top: 4px;
    }

    #showParkFee .detail {
        padding: 12px;
        background-color: white;
        border-bottom: #efefef solid 1px;
    }

    #showParkFee .detail .v-split-line {
        height: 0;
        width: 100%;
        margin-bottom: 12px;
        border-top: 1px solid #EEEEEE;
    }

    #showParkFee .detail .item {
        display: flex;
        align-items: center;
        justify-content: space-between;

        font-size: 14px;
        font-weight: 500;
    }

    #showParkFee .detail .item + .item {
        margin-top: 8px;
    }

    #showParkFee .detail .item .label {
        color: #666666;
    }

    #showParkFee .detail .item .value {
        color: #333333;
    }

    #showParkFee .submit-button {
        padding: 6px 12px 0 12px;
    }

    #showParkFee .submit-button .label {
        color: #333333;
        font-size: 14px;
        font-weight: 400;
    }

    #showParkFee .submit-button .pay-money {
        display: flex;
        margin-top: 8px;
        align-items: center;
        justify-content: space-between;
    }

    #showParkFee .submit-button .pay-money .left,
    #showParkFee .submit-button .pay-money .use-balance {
        display: flex;
        align-items: center;
    }

    #showParkFee .submit-button .pay-money .left .money {
        font-size: 18px;
        font-weight: bold;
        color: rgba(253, 93, 15, 1);
    }

    #showParkFee .submit-button .pay-money .left .balance {
        color: #666666;
        font-size: 12px;
        font-weight: 400;
    }

    #showParkFee .submit-button .pay-money .use-balance {
        color: #666666;
        font-size: 12px;
        font-weight: 400;
    }

    #showParkFee .submit-button .pay-money .use-balance .text {
        margin-left: 2px;
    }

    #showParkFee .submit-button .tip {
        margin: 8px 0;
        display: flex;
        color: #999999;
        font-size: 12px;
        font-weight: 400;
        align-items: center;
    }

    #showParkFee .car-entry-img {
        margin: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
